<template>
    <page :showBackButton="true">
        <!-- <template v-slot:header>
      <ion-title>Berater</ion-title>
    </template> -->

        <!-- <ion-button @click="openCoachContactModal()">KONTAKT</ion-button> -->
        <ion-card class="c-coach-card-details">
            <ion-grid>
                <ion-row>
                    <ion-col
                        class="c-coach-card-details__text"
                        size="7"
                        size-md="9"
                    >
                        <div style="font-size: large;" class="u-m-bottom-small">
                            {{ genderText }}
                        </div>
                        <h4>
                            <b>{{ coach.name }}</b>
                        </h4>
                    </ion-col>
                    <ion-col
                        class="c-coach-card-details__image"
                        size="5"
                        size-md="3"
                        :style="
                            'background-image: url(' +
                            baseurl +
                            api_static +
                            '?Mode=General&Function=BeraterImage&size=250&agentId=' +
                            coach.agentId +
                            ')'
                        "
                    >
                        <!-- <img :src="baseurl + api_static + '?Mode=General&Function=BeraterImage&agentId=' + coach.agentId"> -->
                    </ion-col>
                </ion-row>
            </ion-grid>
            <ion-grid class="c-coach-card-details__contact">
                <ion-row
                    class="ion-text-center ion-align-items-center u-m-bottom-small u-m-top-small"
                >
                    <ion-col size="4">
                        <!-- <ion-button
                            expand="full"
                            fill="clear"
                            size="large"
                            color="dark"
                            @click="openCoachContactModal()"
                        > -->
                        <!-- <ion-icon
                slot="icon-only"
                name="mail"
              ></ion-icon> -->
                        <a @click="openCoachContactModal()">
                            <span class="icon-nachricht"></span>
                            <div>E-Mail</div>
                        </a>
                        <!-- </ion-button> -->
                    </ion-col>
                    <!-- <ion-col size="3">
                        <a @click="goToVideoTermin">
                            <span class="icon-video"></span>
                            <div>Termin</div>
                        </a>
                    </ion-col> -->
                    <ion-col size="4">
                        <!-- <ion-button
                            expand="full"
                            fill="clear"
                            size="large"
                            color="dark"
                            :href="'tel:' + (coach['mobile'] || coach['phone'])"
                        > -->
                        <!-- <ion-icon
                slot="icon-only"
                name="call"
              ></ion-icon> -->
                        <a :href="'tel:' + (coach['mobile'] || coach['phone'])">
                            <span class="icon-telefon"></span>
                            <div>Anruf</div>
                        </a>
                        <!-- </ion-button> -->
                    </ion-col>
                    <ion-col size="4">
                        <!-- <ion-button
                            expand="full"
                            fill="clear"
                            size="large"
                            color="dark"
                            :href="
                                'https://www.google.com/maps/dir/?api=1&destination=' +
                                coach['lat'] +
                                ',' +
                                coach['lng']
                            "
                            target="_blank"
                        > -->
                        <!-- <ion-icon
                slot="icon-only"
                name="navigate"
              ></ion-icon> -->
                        <a
                            :href="
                                'https://www.google.com/maps/dir/?api=1&destination=' +
                                coach['lat'] +
                                ',' +
                                coach['lng']
                            "
                            target="_blank"
                        >
                            <span class="icon-route"></span>
                            <div>Route</div>
                        </a>
                        <!-- </ion-button> -->
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <!-- 
    <ion-segment @ionChange="segmentChanged($event)">
      <ion-segment-button
        value="uebersicht"
        checked
      >
        <ion-label>Übersicht</ion-label>
      </ion-segment-button>
      <ion-segment-button value="karte">
        <ion-label>Karte</ion-label>
      </ion-segment-button>
      <ion-segment-button value="rezensionen">
        <ion-label>Rezensionen</ion-label>
      </ion-segment-button>
    </ion-segment>

    <div v-show="selectedSegment === 'uebersicht'">uebersicht</div>
    <div v-show="selectedSegment === 'karte'">karte</div>
    <div v-show="selectedSegment === 'rezensionen'">rezensionen</div> -->
        <!-- https://www.google.com/maps/dir/?api=1&destination=41.43206,-81.38992 -->
        <ion-list>
            <ion-list-header>
                Kontaktdaten
            </ion-list-header>

            <ion-item v-if="coach['phone'] != ''">
                <ion-label class="ion-text-wrap">Telefon</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end"
                        ><a :href="'tel:' + coach['phone']" target="_blank">{{
                            coach["phone"]
                        }}</a></b
                    ></ion-label
                >
                <ion-button
                    class="c-copybutton"
                    fill="clear"
                    @click="copyValue(coach['phone'], 'Telefon')"
                >
                    <ion-icon
                        slot="icon-only"
                        ios="md-copy"
                        md="md-copy"
                    ></ion-icon>
                </ion-button>
            </ion-item>
            <ion-item v-if="coach['mobile'] != ''">
                <ion-label class="ion-text-wrap">Mobil</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end"
                        ><a :href="'tel:' + coach['mobile']" target="_blank">{{
                            coach["mobile"]
                        }}</a></b
                    ></ion-label
                >
                <ion-button
                    class="c-copybutton"
                    fill="clear"
                    @click="copyValue(coach['mobile'], 'Mobil')"
                >
                    <ion-icon
                        slot="icon-only"
                        ios="md-copy"
                        md="md-copy"
                    ></ion-icon>
                </ion-button>
            </ion-item>
            <ion-item v-if="coach['fax'] != ''">
                <ion-label class="ion-text-wrap">Fax</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end"
                        ><a :href="'fax:' + coach['fax']" target="_blank">{{
                            coach["fax"]
                        }}</a></b
                    ></ion-label
                >
                <ion-button
                    class="c-copybutton"
                    fill="clear"
                    @click="copyValue(coach['fax'], 'Fax')"
                >
                    <ion-icon
                        slot="icon-only"
                        ios="md-copy"
                        md="md-copy"
                    ></ion-icon>
                </ion-button>
            </ion-item>
            <ion-item v-if="coach['email'] != ''">
                <ion-label class="ion-text-wrap">E-Mail</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end"
                        ><a
                            :href="'mailto:' + coach['email']"
                            target="_blank"
                            >{{ coach["email"] }}</a
                        ></b
                    ></ion-label
                >
                <ion-button
                    class="c-copybutton"
                    fill="clear"
                    @click="copyValue(coach['email'], 'E-Mail')"
                >
                    <ion-icon
                        slot="icon-only"
                        ios="md-copy"
                        md="md-copy"
                    ></ion-icon>
                </ion-button>
            </ion-item>
        </ion-list>

        <ion-list>
            <ion-list-header>
                Standort
            </ion-list-header>
            <ion-item v-if="coach['address'] != ''">
                <ion-label class="ion-text-wrap">Adresse</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end">{{ coach["address"] }} </b>
                </ion-label>
            </ion-item>
            <ion-item v-if="coach['zip'] != '' && coach['city'] != ''">
                <ion-label class="ion-text-wrap">Ort</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end">{{ coach["zip"] }} {{ coach["city"] }} </b>
                </ion-label>
            </ion-item>
        </ion-list>

        <ion-list>
            <ion-list-header>
                Zahlungsmöglichkeiten
            </ion-list-header>
            <ion-item>
                <ion-label class="ion-text-wrap">Bargeld</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end" v-html="coach['paymentCash'] ? 'Ja' : '-'">
                    </b>
                </ion-label>
            </ion-item>
            <ion-item>
                <ion-label class="ion-text-wrap">Bankomatkasse</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b slot="end" v-html="coach['paymentAtm'] ? 'Ja' : '-'">
                    </b>
                </ion-label>
            </ion-item>
            <ion-item>
                <ion-label class="ion-text-wrap">Kreditkarte</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">
                    <b
                        slot="end"
                        v-html="coach['paymentCreditcard'] ? 'Ja' : '-'"
                    >
                    </b>
                </ion-label>
            </ion-item>
        </ion-list>

        <ion-list>
            <template v-if="Object.keys(openingHours).length > 0">
                <ion-list-header>
                    Öffnungszeiten
                </ion-list-header>

                <ion-item v-for="(value, key) in openingHours" :key="key">
                    <ion-label class="ion-text-wrap">{{ key }}</ion-label>
                    <ion-label class="ion-text-wrap ion-text-right">
                        <b slot="end">{{ value }} </b>
                    </ion-label>
                </ion-item>
            </template>
        </ion-list>

        <!-- <p>
            <b>Du möchtest ein digitales Beratungsgespräch vereinbaren?</b>
            <br />
            Reserviere dir online einen Termin und stell deine Fragen bequem von
            zuhause aus in einem Video Call.
        </p>
        <div class="ion-text-center">
            <ion-button @click="goToVideoTermin"
                >Termin online vereinbaren</ion-button
            >
        </div> -->

        <!-- <div
      v-for="(value, key) in coach"
      class="ion-margin-bottom"
      :key="key"
    >
      {{ key }}: {{ value }}
    </div> -->
        <!-- </ion-list> -->
    </page>
</template>

<script>
import Page from "@/components/Page";
import { BASEURL } from "@/utils/globals";
import CoachContactModal from "@/components/CoachContactModal";
import { Plugins } from "@capacitor/core";

const { Clipboard } = Plugins;

export default {
    components: { Page },
    props: ["contractId", "directContact", "motive"],
    data() {
        return {
            baseurl: BASEURL,
            api_static: process.env.VUE_APP_API_STATIC,
            selectedSegment: "uebersicht",
        };
    },
    mounted() {
        // console.log(this.directContact);
        if (this.directContact) {
            this.openCoachContactModal();
        }
        this.$store.cache.dispatch("coaches/getCoach", this.contractId);
    },
    methods: {
        goToVideoTermin() {
            this.$router.push({
                name: "video-termin",
                params: {
                    agentId: this.coach.agentId,
                    contractId: this.contractId,
                    agentName: this.coach.name,
                    motive: this.motive,
                },
            });
        },
        segmentChanged(e) {
            this.selectedSegment = e.detail.value;
        },
        openCoachContactModal() {
            this.$ionic.modalController
                .create({
                    component: CoachContactModal,
                    componentProps: {
                        propsData: {
                            agentId: this.coach.agentId,
                            agentName: this.coach.name,
                            contractId: this.contractId,
                            motive: this.motive,
                        },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
        copyValue(value, label) {
            Clipboard.write({ string: value }).then(() => {
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: label + " wurde kopiert",
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            });
        },
    },
    computed: {
        genderText() {
            let result = "Dein Berater";
            if (this.coach.gender && this.coach.gender === "W") {
                result = "Deine Beraterin";
            }
            return result;
        },
        coach() {
            let result = {};
            if (this.contractId in this.$store.state.coaches.all) {
                result = this.$store.state.coaches.all[this.contractId];
            }
            return result;
        },
        openingHours() {
            let result = {};
            if ("openinghours" in this.coach) {
                // console.log();
                // result = JSON.parse(this.coach.openinghours);

                result = this.coach.openinghours;
            }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-coach-card-details {
    border: solid 1px var(--ion-color-medium);
    padding: 0;

    &__text {
        padding: var(--gangl-padding-medium);
        padding-bottom: var(--gangl-padding-xxlarge);
    }
    &__image {
        // padding: 0;
        background-size: cover;
        background-position: center;

        &:after {
            content: "";
            display: block;
            padding-bottom: 99%;
        }
    }
    &__contact {
        border-top: solid 1px var(--ion-color-medium-shade);

        [class^="icon-"],
        [class*=" icon-"] {
            font-size: x-large;
            font-weight: bold;
        }

        a {
            cursor: pointer;
            color: var(--ion-color-dark);
            display: block;
            &:hover {
                opacity: 0.6;
            }
        }
    }
}

ion-list {
    a {
        color: var(--ion-color-light-contrast);
        text-decoration: none;
    }
}

.c-copybutton {
    --padding-start: 2px;
    --padding-end: 2px;
}
</style>

<style lang="scss">
ion-list ion-label {
    flex: unset;
    flex-grow: 1;
}
</style>
